import { useMutation } from '@tanstack/react-query';

import { userUpdatePassword } from '@api/sdk.gen';

import { UserId } from '@/portainer/users/types';
import { withError } from '@/react-tools/react-query';

export function useChangeOwnPasswordMutation(userId: UserId) {
  return useMutation({
    mutationFn: ({
      currentPassword,
      newPassword,
    }: {
      currentPassword: string;
      newPassword: string;
    }) => changeOwnPassword(userId, currentPassword, newPassword),
    ...withError('Unable to update the password'),
  });
}

async function changeOwnPassword(
  userId: UserId,
  currentPassword: string,
  newPassword: string
) {
  await userUpdatePassword({
    path: { id: userId },
    body: { Password: currentPassword, NewPassword: newPassword },
  });
}
